function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
// import { Card, CardBody, CardTitle, CardSubtitle } from 'reactstrap';
import React from 'react';
import PropTypes from 'prop-types';
import { Card } from 'react-bootstrap';
const DashCard = _ref => {
  let {
    children,
    title,
    subtitle,
    actions,
    titleContainerClassName = '',
    titleClassName = '',
    titleSmall = false,
    cardStyle = {},
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(Card, _extends({}, props, {
    style: {
      borderRadius: '1.5rem',
      ...cardStyle
    }
  }), /*#__PURE__*/React.createElement(Card.Body, null, /*#__PURE__*/React.createElement("div", {
    className: `d-md-flex ${titleContainerClassName}`
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Card.Title, {
    className: `dashboard-card-title ${titleSmall ? 'dashboard-card-title-small' : ''} ${titleClassName}`,
    tag: "h4"
  }, title), /*#__PURE__*/React.createElement(Card.Text, {
    className: "text-muted"
  }, subtitle)), /*#__PURE__*/React.createElement("div", {
    className: "ms-auto mt-3 mt-md-0"
  }, actions)), /*#__PURE__*/React.createElement("div", {
    className: "mt-3"
  }, children)));
};
DashCard.propTypes = {
  children: PropTypes.node,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  actions: PropTypes.node
};
export default DashCard;